import { Cookie } from 'bobjoll/ts/library/cookie';


export const cookie = Cookie;